var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8FlcheRpondreTous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 17.470703 11.986328 A 1.50015 1.50015 0 0 0 16.439453 12.439453 L 6.4394531 22.439453 A 1.50015 1.50015 0 0 0 6.4394531 24.560547 L 16.439453 34.560547 A 1.50015 1.50015 0 1 0 18.560547 32.439453 L 9.6210938 23.5 L 18.560547 14.560547 A 1.50015 1.50015 0 0 0 17.470703 11.986328 z M 25.470703 11.986328 A 1.50015 1.50015 0 0 0 24.439453 12.439453 L 14.439453 22.439453 A 1.50015 1.50015 0 0 0 14.439453 24.560547 L 24.439453 34.560547 A 1.50015 1.50015 0 1 0 26.560547 32.439453 L 19.121094 25 L 26.5 25 C 33.421343 25 39 30.578657 39 37.5 A 1.50015 1.50015 0 1 0 42 37.5 C 42 28.957343 35.042657 22 26.5 22 L 19.121094 22 L 26.560547 14.560547 A 1.50015 1.50015 0 0 0 25.470703 11.986328 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FlcheRpondreTous);
export default __webpack_public_path__ + "static/media/icons8-flèche-répondre-à-tous.24dfae29c4bf258fcff8e74424643e60.svg";
export { ForwardRef as ReactComponent };